import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IUserReference } from 'user/user-reference';

@Component({
	selector: 'spr-coach-profile-certificates',
	templateUrl: './coach-profile-certificates.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoachProfileCertificatesComponent {
	@Input() public certificates: IUserReference[];

	constructor() {}
}
